declare global {
  interface RouterMeta {
    title: string;
  }
  interface Router {
    path: string;
    name: string;
    icon?: string;
    permission?: string;
    meta?: RouterMeta;
    component: any;
    children?: Array<Router>;
  }
  interface System {
    import(request: string): Promise<any>;
  }
  var System: System;
}
import login from '../views/login.vue';
import main from '../views/main.vue';
import flightSearch from '../views/pages/flight/flightSearch.vue';
import flightReservationMonitor from '../views/pages/flight/flightReservationMonitor.vue';
import flightMonitor from '../views/pages/flight/flightMonitor.vue';
import flightWizard from '../views/pages/flight/flightWizard.vue';
import flightChange from '../views/pages/flight/flightChange.vue';
import flightReservationRefund from '../views/pages/flight/flightReservationRefund.vue';
import flightChangeChecklist from '../views/pages/flight/flightChangeChecklist.vue';
import flightPassengerList from '../views/pages/flight/flightPassengerList.vue';
import flightControl from '../views/pages/flight/flightControl.vue';
import flightOrderChange from '../views/pages/flight/flightOrderChange.vue';
import emailRecordingHistory from '../views/pages/flight/emailRecordingHistory.vue';
import webServiceMarkup from '../views/pages/flight/webServiceMarkup.vue';
import providerMarkup from '../views/pages/flight/providerMarkup.vue';
import queryTool from '../views/pages/flight/queryTool.vue';
import xml from '../views/pages/flight/xml.vue';
import airports from '../views/pages/definitions/airports.vue';
import terminals from '../views/pages/definitions/terminals.vue';
import companies from '../views/pages/definitions/companies.vue';
import providers from '../views/pages/definitions/providers.vue';
import aircraftTypes from '../views/pages/definitions/aircraftTypes.vue';
import flightClasses from '../views/pages/definitions/flightClasses.vue';
import flightSegments from '../views/pages/definitions/flightSegments.vue';
import salesChannels from '../views/pages/definitions/salesChannels.vue';
import penaltyRules from '../views/pages/definitions/penaltyRules.vue';
import exchangeRates from '../views/pages/definitions/exchangeRates.vue';
import flightRoutes from '../views/pages/definitions/flightRoutes.vue';
import agencies from '../views/pages/definitions/agencies.vue';
import currencies from '../views/pages/definitions/currencies.vue';
import accountBalanceManagement from '../views/pages/finance/accountBalanceManagements.vue';
import accountActivities from '../views/pages/finance/accountActivities.vue';
import banks from '../views/pages/finance/banks.vue';
import bankAccounts from '../views/pages/finance/bankAccounts.vue';
import bankPos from '../views/pages/finance/bankPos.vue';
import exchangeRateUpdate from '../views/pages/finance/exchangeRateUpdate.vue';
import ticketReservationMonitor from '../views/pages/tickets/ticketReservationMonitor.vue';
import reservationRefund from '../views/pages/tickets/reservationRefund.vue';
import systemControl from '../views/pages/systemControl.vue';
import userManagement from '../views/pages/users/userManagement.vue';
import transferReservationMonitor from '../views/pages/transfer/transferReservationMonitor.vue';
import transferPassengerList from '../views/pages/transfer/transferPassengerList.vue';
import transferRegions from '../views/pages/transfer/transferRegions.vue';
import transfers from '../views/pages/transfer/transfers.vue';
import serviceLogs from '../views/pages/logs/serviceLogs.vue';
import botManagement from '../views/pages/botManagement.vue';
import queryStatistics from '../views/pages/statistics/queryStatistics.vue';

export const loginRouter: Router = {
  path: '/',
  name: 'login',
  meta: {
    title: 'LogIn',
  },
  component: () => import('../views/login.vue'),
};

export const otherRouters: Router = {
  path: '/main',
  name: 'main',
  permission: '',
  meta: { title: 'ManageMenu' },
  component: main,
  children: [
    {
      path: 'home',
      meta: { title: 'HomePage' },
      name: 'home',
      component: () => import('../views/pages/home.vue'),
    },
  ],
};



export const appRouters: Array<Router> = [
  {
    path: '/pages/flight',
    name: 'flight',
    permission: '',
    meta: { title: 'ManageMenu' },
    icon: '&#xe68a;',
    component: main,
    children: [
      {
        path: 'flightSearch',
        meta: { title: 'Flight Search' },
        name: 'flightSearch',
        component: () => import('../views/pages/flight/flightSearch.vue'),
      },
      {
        path: 'systemControl',
        meta: { title: 'System Control' },
        name: 'systemControl',
        component: () => import('../views/pages/systemControl.vue'),
      },


      {
        path: 'flightReservationMonitor',
        meta: { title: 'Flight Reservation Monitor' },
        name: 'flightReservationMonitor',
        component: () =>
          import('../views/pages/flight/flightReservationMonitor.vue'),
      },
      {
        path: 'flightReservationRefund',
        meta: { title: 'Flight Reservation Refund' },
        name: 'flightReservationRefund',
        component: () =>
          import('../views/pages/flight/flightReservationRefund.vue'),
      },
      {
        path: 'flightMonitor',
        meta: { title: 'Flight Monitor' },
        name: 'flightMonitor',
        component: () => import('../views/pages/flight/flightMonitor.vue'),
      },
      {
        path: 'flightWizard',
        meta: { title: 'Flight Wizard' },
        name: 'flightWizard',
        component: () => import('../views/pages/flight/flightWizard.vue'),
      },
      {
        path: 'flightChange',
        meta: { title: 'Flight Change' },
        name: 'flightChange',
        component: () => import('../views/pages/flight/flightChange.vue'),
      },
      {
        path: 'flightChangeChecklist',
        meta: { title: 'Flight Change Checklist' },
        name: 'flightChangeChecklist',
        component: () =>
          import('../views/pages/flight/flightChangeChecklist.vue'),
      },
      {
        path: 'flightPassengerList',
        meta: { title: 'Flight Passenger List' },
        name: 'flightPassengerList',
        component: () =>
          import('../views/pages/flight/flightPassengerList.vue'),
      },
      {
        path: 'flightControl',
        meta: { title: 'Flight Control' },
        name: 'flightControl',
        component: () => import('../views/pages/flight/flightControl.vue'),
      },
      {
        path: 'flightOrderChange',
        meta: { title: 'Flight Order Change' },
        name: 'flightOrderChange',
        component: () => import('../views/pages/flight/flightOrderChange.vue'),
      },
      {
        path: 'emailRecordingHistory',
        meta: { title: 'Email Recording History' },
        name: 'emailRecordingHistory',
        component: () =>
          import('../views/pages/flight/emailRecordingHistory.vue'),
      },
      {
        path: 'webServiceMarkup',
        meta: { title: 'Web Service Markup' },
        name: 'webServiceMarkup',
        component: () => import('../views/pages/flight/webServiceMarkup.vue'),
      },
      {
        path: 'providerMarkup',
        meta: { title: 'Provider Markup' },
        name: 'providerMarkup',
        component: () => import('../views/pages/flight/providerMarkup.vue'),
      },
      {
        path: 'queryTool',
        meta: { title: 'Query Tool' },
        name: 'queryTool',
        component: () => import('../views/pages/flight/queryTool.vue'),
      },
      {
        path: 'xml',
        meta: { title: 'XML' },
        name: 'xml',
        component: () => import('../views/pages/flight/xml.vue'),
      },
      {
        path: 'paxReport',
        meta: { title: 'Pax Report' },
        name: 'paxReport',
        component: () => import('../views/pages/flight/paxReport.vue'),
      },

      {
        path: 'flightSearch',
        meta: { title: 'Flight Search' },
        name: 'paxReport',
        component: () => import('../views/pages/flight/flightSearch.vue'),
      },
      {
        path: 'servisMarkup',
        meta: { title: 'Provider Markup' },
        name: 'servisMarkup',
        component: () => import('../views/pages/flight/servisMarkup.vue'),
      },
    ],
  },

  {
    path: '/pages/tickets',
    name: 'tickets',
    permission: '',
    meta: { title: 'ManageMenu' },
    icon: '&#xe68a;',
    component: main,
    children: [
      {
        path: 'ticketReservationMonitor',
        meta: { title: 'Ticket Reservation Monitor' },
        name: 'ticketReservationMonitor',
        component: () =>
          import('../views/pages/tickets/ticketReservationMonitor.vue'),
      },
      {
        path: 'reservationRefund',
        meta: { title: 'Reservation Refund' },
        name: 'reservationRefund',
        component: () => import('../views/pages/tickets/reservationRefund.vue'),
      },
    ],
  },

  {
    path: '/pages/users',
    name: 'users',
    permission: '',
    meta: { title: 'ManageMenu' },
    icon: '&#xe68a;',
    component: main,
    children: [
      {
        path: 'userManagement',
        meta: { title: 'User Management' },
        name: 'userManagement',
        component: () => import('../views/pages/users/userManagement.vue'),
      },
      {
        path: 'apiUserCreate',
        meta: { title: 'API User Create' },
        name: 'apiUserCreate',
        component: () => import('../views/pages/users/apiUserCreate.vue'),
      },
    ],
  },

  {
    path: '/pages/definitions',
    name: 'definitions',
    permission: '',
    meta: { title: 'ManageMenu' },
    icon: '&#xe68a;',
    component: main,
    children: [
      {
        path: 'airports',
        meta: { title: 'Airports' },
        name: 'airports',
        component: () => import('../views/pages/definitions/airports.vue'),
      },
      {
        path: 'terminals',
        meta: { title: 'Terminals' },
        name: 'terminals',
        component: () => import('../views/pages/definitions/terminals.vue'),
      },
      {
        path: 'companies',
        meta: { title: 'Companies' },
        name: 'companies',
        component: () => import('../views/pages/definitions/companies.vue'),
      },
      {
        path: 'providers',
        meta: { title: 'Providers' },
        name: 'providers',
        component: () => import('../views/pages/definitions/providers.vue'),
      },
      {
        path: 'aircraftTypes',
        meta: { title: 'Aircraft Types' },
        name: 'aircraftTypes',
        component: () => import('../views/pages/definitions/aircraftTypes.vue'),
      },
      {
        path: 'flightClasses',
        meta: { title: 'Flight Classes' },
        name: 'flightClasses',
        component: () => import('../views/pages/definitions/flightClasses.vue'),
      },
      {
        path: 'flightSegments',
        meta: { title: 'Flight Segments' },
        name: 'flightSegments',
        component: () =>
          import('../views/pages/definitions/flightSegments.vue'),
      },
      {
        path: 'salesChannels',
        meta: { title: 'Sales Channels' },
        name: 'salesChannels',
        component: () => import('../views/pages/definitions/salesChannels.vue'),
      },
      {
        path: 'penaltyRules',
        meta: { title: 'Penalty Rules' },
        name: 'penaltyRules',
        component: () => import('../views/pages/definitions/penaltyRules.vue'),
      },
      {
        path: 'exchangeRates',
        meta: { title: 'Exchange Rates' },
        name: 'exchangeRates',
        component: () => import('../views/pages/definitions/exchangeRates.vue'),
      },
      {
        path: 'flightRoutes',
        meta: { title: 'Flight Routes' },
        name: 'flightRoutes',
        component: () => import('../views/pages/definitions/flightRoutes.vue'),
      },
      {
        path: 'agencies',
        meta: { title: 'Agencies' },
        name: 'agencies',
        component: () => import('../views/pages/definitions/agencies.vue'),
      },
      {
        path: 'currencies',
        meta: { title: 'Currencies' },
        name: 'currencies',
        component: () => import('../views/pages/definitions/currencies.vue'),
      },
      {
        path: 'countries',
        meta: { title: 'Countries' },
        name: 'countries',
        component: () => import('../views/pages/definitions/countries.vue'),
      },
      {
        path: 'cities',
        meta: { title: 'Cities' },
        name: 'cities',
        component: () => import('../views/pages/definitions/cities.vue'),
      },
      {
        path: 'flightRoutesXML',
        meta: { title: 'Flight Routes XML' },
        name: 'flightRoutesXML',
        component: () => import('../views/pages/definitions/flightRoutesXML.vue'),
      },
    ],
  },

  {
    path: '/pages/finance',
    name: 'finance',
    permission: '',
    meta: { title: 'ManageMenu' },
    icon: '&#xe68a;',
    component: main,
    children: [
      {
        path: 'accountBalanceManagements',
        meta: { title: 'Account Balance Managements' },
        name: 'accountBalanceManagements',
        component: () =>
          import('../views/pages/finance/accountBalanceManagements.vue'),
      },
      {
        path: 'accountActivities',
        meta: { title: 'Account Activities' },
        name: 'accountActivities',
        component: () => import('../views/pages/finance/accountActivities.vue'),
      },
      {
        path: 'banks',
        meta: { title: 'Banks' },
        name: 'banks',
        component: () => import('../views/pages/finance/banks.vue'),
      },
      {
        path: 'bankAccounts',
        meta: { title: 'Bank Accounts' },
        name: 'bankAccounts',
        component: () => import('../views/pages/finance/bankAccounts.vue'),
      },
      {
        path: 'bankPos',
        meta: { title: 'Bank Pos' },
        name: 'bankPos',
        component: () => import('../views/pages/finance/bankPos.vue'),
      },
      {
        path: 'exchangeRateUpdate',
        meta: { title: 'Exchange Rate Update' },
        name: 'exchangeRateUpdate',
        component: () =>
          import('../views/pages/finance/exchangeRateUpdate.vue'),
      },
    ],
  },

  {
    path: '/pages/transfer',
    name: 'transfer',
    permission: '',
    meta: { title: 'ManageMenu' },
    icon: '&#xe68a;',
    component: main,
    children: [

      {
        path: 'transferReservationMonitor',
        meta: { title: 'Transfer Reservation Monitor' },
        name: 'transferReservationMonitor',
        component: () =>
          import('../views/pages/transfer/transferReservationMonitor.vue'),
      },
      {
        path: 'transferPassengerList',
        meta: { title: 'Transfer Passenger List' },
        name: 'transferPassengerList',
        component: () =>
          import('../views/pages/transfer/transferPassengerList.vue'),
      },
      {
        path: 'transferRegions',
        meta: { title: 'Transfer Regions' },
        name: 'transferRegions',
        component: () =>
          import('../views/pages/transfer/transferRegions.vue'),
      },
      {
        path: 'transfers',
        meta: { title: 'Transfers' },
        name: 'transfers',
        component: () =>
          import('../views/pages/transfer/transfers.vue'),
      },

    ],
  },

  {
    path: '/pages/logs',
    name: 'logs',
    permission: '',
    meta: { title: 'ManageMenu' },
    icon: '&#xe68a;',
    component: main,
    children: [
      {
        path: 'serviceLogs',
        meta: { title: 'Service Logs' },
        name: 'serviceLogs',
        component: () => import('../views/pages/logs/serviceLogs.vue'),
      },
    ],
  },

  {
    path: '/pages/bot',
    name: 'bot',
    permission: '',
    meta: { title: 'ManageMenu' },
    icon: '&#xe68a;',
    component: main,
    children: [
      {
        path: 'botManagement',
        meta: { title: 'Bot Management' },
        name: 'botManagement',
        component: () => import('../views/pages/botManagement.vue'),
      },
    ],
  },

  {
    path: '/pages/statistics',
    name: 'statistics',
    permission: '',
    meta: { title: 'ManageMenu' },
    icon: '&#xe68a;',
    component: main,
    children: [
      {
        path: 'queryStatistics',
        meta: { title: 'Query Statistics' },
        name: 'queryStatistics',
        component: () => import('../views/pages/statistics/queryStatistics.vue'),
      },
    ],
  },
];

export const routers = [loginRouter, ...appRouters, otherRouters];
